import { useSchedule, useUpdateShift } from '../hooks/useSchedule.js';
import { useError } from '../components/shared/ErrorBanner.jsx';

// Crew view: upcoming shifts (next 30 days) with confirm / decline
// buttons on planned rows. Past + cancelled rows hidden by default.
export default function SchedulePage() {
  const now = Date.now();
  const { data: shifts = [], isLoading } = useSchedule({
    target: 'me',
    from: now,
    to: now + 30 * 86400000,
  });
  const upcoming = shifts
    .filter(s => s.status !== 'cancelled' && s.end_at >= now)
    .sort((a, b) => a.start_at - b.start_at);

  return (
    <div className="panel">
      <h3 className="panel-title">
        <span><i className="ph ph-calendar" /> My schedule</span>
      </h3>
      {isLoading ? (
        <div className="loading">Loading…</div>
      ) : upcoming.length === 0 ? (
        <div className="loading">Nothing on the books in the next 30 days.</div>
      ) : (
        <ul className="schedule-list">
          {upcoming.map(s => <ShiftRow key={s.id} s={s} />)}
        </ul>
      )}
    </div>
  );
}

function ShiftRow({ s }) {
  const update = useUpdateShift();
  const { show } = useError();
  const planned = s.status === 'planned';

  const onSet = async (status) => {
    try { await update.mutateAsync({ id: s.id, status }); }
    catch (err) { show(err.message); }
  };

  return (
    <li className={'schedule-row status-' + s.status}>
      <div className="schedule-main">
        <div className="schedule-when">{formatRange(s.start_at, s.end_at)}</div>
        <div className="schedule-meta">
          {s.job_name || 'No job assigned'}
          {' · '}<span className="badge">{s.status}</span>
          {s.notes && <div className="schedule-notes">{s.notes}</div>}
        </div>
      </div>
      {planned && (
        <div className="schedule-actions">
          <button className="btn-sm primary" onClick={() => onSet('confirmed')} disabled={update.isPending}>
            Confirm
          </button>
          <button className="btn-sm" onClick={() => onSet('declined')} disabled={update.isPending}>
            Decline
          </button>
        </div>
      )}
    </li>
  );
}

function formatRange(start, end) {
  const s = new Date(start);
  const e = new Date(end);
  const sameDay = s.toDateString() === e.toDateString();
  const dateOpts = { weekday: 'short', month: 'short', day: 'numeric' };
  const timeOpts = { hour: 'numeric', minute: '2-digit' };
  if (sameDay) {
    return `${s.toLocaleDateString(undefined, dateOpts)} · ${s.toLocaleTimeString(undefined, timeOpts)} – ${e.toLocaleTimeString(undefined, timeOpts)}`;
  }
  return `${s.toLocaleString(undefined, { ...dateOpts, ...timeOpts })} → ${e.toLocaleString(undefined, { ...dateOpts, ...timeOpts })}`;
}
